import { SubjectPayloadInterface } from "../../Constants/Interfaces/payloadInterface/SubjectPayload.interface";

export const validateSubjectForm = (
  values: SubjectPayloadInterface
): string | null => {
  if (!values.name) {
    return "Subject name is required.";
  }

  if (!values.subject_type) {
    return "Please select subject type.";
  }

  return null;
};
